import IAction from "../../types/IAction";
import { readMessageBack } from "../../utils/readMessageBack";
import actionTypes from "../actionTypes";
import CoordinadorAdministrativoCalificacion from "../../types/CoordinadorAdministrativoCalificacion";
import ComisionManual from "../../types/ComisionManual";

export interface PostProcesarExcel {
  calificaciones: CoordinadorAdministrativoCalificacion[];
  postingProcesarExcel: boolean;
  postingProcesarExcelError: string;
}

export interface GetComisionesPorPeriodo {
  comisiones: ComisionManual[];
  gettingComisiones: boolean;
  gettingComisionesError: string;
}

interface State extends PostProcesarExcel, GetComisionesPorPeriodo {}

const initialState: State = {
  calificaciones: null,
  postingProcesarExcel: false,
  postingProcesarExcelError: null,
  comisiones: null,
  gettingComisiones: false,
  gettingComisionesError: null
};

export default function comisionCoordinadorAdministrativoReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(state: State = initialState, action: IAction) {
  switch (action.type) {
    case `${actionTypes.POST_COMISION_COORDINADOR_ADMINISTRATIVO_PROCESAR_EXCEL}_PENDING`: {
      return {
        postingProcesarExcel: true,
        postingProcesarExcelError: null
      };
    }
    case `${actionTypes.POST_COMISION_COORDINADOR_ADMINISTRATIVO_PROCESAR_EXCEL}_REJECTED`: {
      return {
        calificaciones: null,
        postingProcesarExcel: false,
        postingProcesarExcelError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_COORDINADOR_ADMINISTRATIVO_PROCESAR_EXCEL}_FULFILLED`: {
      return {
        calificaciones: action.payload.data,
        postingProcesarExcel: false,
        postingProcesarExcelError: null
      };
    }

    case `${actionTypes.GET_COMISION_COORDINADOR_ADMINISTRATIVO_BY_PERIODO}_PENDING`: {
      return {
        gettingComisiones: true,
        gettingComisionesError: null
      };
    }
    case `${actionTypes.GET_COMISION_COORDINADOR_ADMINISTRATIVO_BY_PERIODO}_REJECTED`: {
      return {
        comisiones: null,
        gettingComisiones: false,
        gettingComisionesError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_COORDINADOR_ADMINISTRATIVO_BY_PERIODO}_FULFILLED`: {
      return {
        comisiones: action.payload.data,
        gettingComisiones: false,
        gettingComisionesError: null
      };
    }

    case actionTypes.CLEAR_COMISION_COORDINADOR_ADMINISTRATIVO:
      return initialState;

    default:
      return state;
  }
}
